export default __webpack_public_path__ + "static/media/wall street icon 3 1.5dbb6d94.svg";